import styled from 'styled-components'
import { BodyLarge, Ellipsize } from '@chegg-wt/core/theme/sunkist/typography'

export const Title = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-grow: 1;
  & :hover {
    text-decoration: none;
  }
`

export const ProjectTitleText = styled.span`
  ${BodyLarge};
  ${Ellipsize};
`

export const TitleContainer = styled.div`
  display: flex;
  cursor: pointer;
  flex-grow: 1;
`
